/**
 * Translations for core  terms.
 *
 * @package translations
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ITranslationManager } from "@adapptio/lib-core";

import runtime_en_US from "../translations/runtime/runtime_en_US.json";
import runtime_cs_CZ from "../translations/runtime/runtime_cs_CZ.json";

/**
 * Registers System translations
 *
 * @param translationManager Translation Manager Instance
 */
export function registerRuntimeTranslations(translationManager: ITranslationManager) {
	translationManager.registerTranslations("runtime", "en_US", runtime_en_US, "translations");
	translationManager.registerTranslations("runtime", "cs_CZ", runtime_cs_CZ, "translations");
}
